<template>
  <div class="lowSource">
    <low-source-search></low-source-search>
    <low-source-container></low-source-container>
  </div>
</template>
<script>
import lowSourceSearch from '@/components/primary/Search.vue'
import lowSourceContainer from '@/components/primary/Container.vue'
export default {
  name: 'lowSource',
  components: {
    lowSourceSearch,
    lowSourceContainer
  }
}
</script>
<style lang="stylus">
.lowSource
  position absolute
  top 20px
  left 20px
  bottom 30px
  right 20px
</style>
